import type { FC } from 'react'
import { EventType } from '@/features/events/shared/types'
import { FileInfo, ToolHeader } from '../shared'

interface ReadContextRendererProps {
  readonly file_path: string
}

export const ReadContextRenderer: FC<ReadContextRendererProps> = ({ file_path }) => {
  return (
    <>
      <ToolHeader eventType={EventType.TOOL_PERMISSION_REQUEST} toolName="Read" />
      <FileInfo filePath={file_path} />
    </>
  )
}
